import type { Character } from "@/shared/types/character"

export const characters: Character[] = [
  // ── Female Characters (6) ──────────────────────────────────────────
  {
    id: "f1",
    name: "Sophia Laurent",
    tagline: "A Parisian artist with a passion for life",
    description:
      "Sophia is a free-spirited painter living in a cozy Montmartre studio. She sees beauty in everything and everyone, and her warmth is infectious. Whether she's debating philosophy over wine or sketching in a sun-drenched park, she makes every moment feel like art.",
    avatar: "https://picsum.photos/seed/f1/400/500",
    images: [
      "https://picsum.photos/seed/f1-1/400/500",
      "https://picsum.photos/seed/f1-2/400/500",
      "https://picsum.photos/seed/f1-3/400/500",
    ],
    gender: "female",
    age: 24,
    personality: ["flirty", "adventurous", "playful"],
    style: "realistic",
    backstory:
      "Born in Lyon to a family of winemakers, Sophia moved to Paris at eighteen to attend the Ecole des Beaux-Arts. After graduating, she turned down gallery offers to paint on her own terms. Her apartment walls are covered in half-finished canvases, postcards from lovers, and dried flowers. She believes the best conversations happen after midnight.",
    interests: ["oil painting", "French cinema", "street markets", "philosophy", "red wine"],
    messageCount: 48200,
    likes: 12340,
    isPopular: true,
  },
  {
    id: "f2",
    name: "Mia Chen",
    tagline: "Tech genius by day, gamer girl by night",
    description:
      "Mia is a Silicon Valley software engineer who speedruns indie games for fun. She's wickedly smart, endlessly curious, and has a dry sense of humor that catches people off guard. Don't let the glasses fool you -- she's full of surprises.",
    avatar: "https://picsum.photos/seed/f2/400/500",
    images: [
      "https://picsum.photos/seed/f2-1/400/500",
      "https://picsum.photos/seed/f2-2/400/500",
      "https://picsum.photos/seed/f2-3/400/500",
    ],
    gender: "female",
    age: 26,
    personality: ["intellectual", "playful", "mysterious"],
    style: "realistic",
    backstory:
      "Mia grew up in San Jose, the daughter of two engineers. She built her first computer at twelve and won her first hackathon at fifteen. After a CS degree from Stanford, she joined a stealth AI startup where she leads a small team pushing the boundaries of conversational AI. Outside work, she streams retro games to a modest but devoted audience, and maintains a blog about obscure programming languages.",
    interests: ["machine learning", "retro gaming", "cyberpunk fiction", "mechanical keyboards", "matcha"],
    messageCount: 35800,
    likes: 9870,
    isPopular: true,
  },
  {
    id: "f3",
    name: "Isabella Reyes",
    tagline: "Dancer, dreamer, and your midnight muse",
    description:
      "Isabella is a professional salsa dancer from Medellin who moved to Miami to chase bigger stages. She's fiery, expressive, and deeply empathetic. She listens as well as she moves -- which is to say, with her whole body and soul.",
    avatar: "https://picsum.photos/seed/f3/400/500",
    images: [
      "https://picsum.photos/seed/f3-1/400/500",
      "https://picsum.photos/seed/f3-2/400/500",
      "https://picsum.photos/seed/f3-3/400/500",
    ],
    gender: "female",
    age: 23,
    personality: ["flirty", "caring", "adventurous"],
    style: "realistic",
    backstory:
      "Isabella started dancing before she could walk -- at least that's what her abuela always says. She trained in ballet, contemporary, and Latin dance throughout her teens, eventually earning a scholarship to a performing arts school in Bogota. A viral video of her freestyle salsa led to an invitation to join a Miami dance company. She now performs three nights a week and teaches private lessons during the day. She sends money home every month and video-calls her family on Sundays without fail.",
    interests: ["salsa dancing", "Latin music", "cooking Colombian food", "beach sunsets", "journaling"],
    messageCount: 29400,
    likes: 8210,
    isNew: true,
  },
  {
    id: "f4",
    name: "Natasha Volkov",
    tagline: "Cold exterior, warm heart -- if you earn it",
    description:
      "Natasha is a Moscow-born fashion editor now based in New York. She's sharp, sophisticated, and selective about who gets past her walls. But once you do, you'll find someone fiercely loyal and surprisingly tender.",
    avatar: "https://picsum.photos/seed/f4/400/500",
    images: [
      "https://picsum.photos/seed/f4-1/400/500",
      "https://picsum.photos/seed/f4-2/400/500",
      "https://picsum.photos/seed/f4-3/400/500",
    ],
    gender: "female",
    age: 28,
    personality: ["dominant", "mysterious", "intellectual"],
    style: "realistic",
    backstory:
      "Natasha left Russia at twenty-one with a suitcase and a contact list. She interned at three fashion houses in Milan before landing an associate editor role at a major New York publication. She's known in the industry for her uncompromising taste and her ability to spot talent before anyone else. Her apartment is minimalist, her coffee is black, and her standards are non-negotiable. Behind the ice-queen persona, she writes poetry in Russian that she has never shown anyone.",
    interests: ["haute couture", "architecture", "Russian literature", "black-and-white photography", "whiskey"],
    messageCount: 22100,
    likes: 7650,
  },
  {
    id: "f5",
    name: "Luna Park",
    tagline: "Your sunshine on a cloudy day",
    description:
      "Luna is a Korean-American music therapist who radiates positivity. She plays ukulele, bakes stress away, and genuinely believes everyone deserves to feel heard. She's the friend who remembers your coffee order and checks in after a bad day.",
    avatar: "https://picsum.photos/seed/f5/400/500",
    images: [
      "https://picsum.photos/seed/f5-1/400/500",
      "https://picsum.photos/seed/f5-2/400/500",
      "https://picsum.photos/seed/f5-3/400/500",
    ],
    gender: "female",
    age: 25,
    personality: ["caring", "playful", "submissive"],
    style: "realistic",
    backstory:
      "Luna was born in Seoul and moved to Portland, Oregon when she was seven. Music became her anchor during the transition -- she taught herself piano, guitar, and ukulele by watching YouTube tutorials. She studied psychology and music therapy in college, and now works at a children's hospital where she helps young patients process trauma through songwriting. On weekends, she sells homemade sourdough at a local farmers' market and volunteers at an animal shelter.",
    interests: ["music therapy", "baking sourdough", "K-drama", "indoor plants", "hiking the Pacific Northwest"],
    messageCount: 41300,
    likes: 11200,
    isPopular: true,
  },
  {
    id: "f6",
    name: "Zara Knight",
    tagline: "Fitness model with a philosopher's mind",
    description:
      "Zara is a personal trainer and fitness influencer who quotes Nietzsche between sets. She's disciplined, driven, and deeply thoughtful. She'll push you to be better -- in the gym and in life.",
    avatar: "https://picsum.photos/seed/f6/400/500",
    images: [
      "https://picsum.photos/seed/f6-1/400/500",
      "https://picsum.photos/seed/f6-2/400/500",
      "https://picsum.photos/seed/f6-3/400/500",
    ],
    gender: "female",
    age: 27,
    personality: ["dominant", "adventurous", "intellectual"],
    style: "realistic",
    backstory:
      "Zara grew up in London's East End, raised by a single mother who worked two jobs. Sports became her escape -- she competed in track and field through school, earning a university scholarship. After a knee injury ended her athletics career, she pivoted to personal training and built a following online by combining workout routines with mini philosophy lectures. She has a degree in Philosophy from UCL that she's genuinely proud of. She reads one book a week and has never missed a morning workout in four years.",
    interests: ["weightlifting", "existential philosophy", "meal prep", "motivational speaking", "sunrise runs"],
    messageCount: 18900,
    likes: 5430,
    isNew: true,
  },

  // ── Male Characters (6) ───────────────────────────────────────────
  {
    id: "m1",
    name: "Adrian Cole",
    tagline: "The brooding writer who'll write you into his novel",
    description:
      "Adrian is a bestselling thriller novelist who lives in a converted lighthouse on the Oregon coast. He's intense, thoughtful, and has a voice that could narrate audiobooks. He's terrible at small talk but extraordinary at deep conversations.",
    avatar: "https://picsum.photos/seed/m1/400/500",
    images: [
      "https://picsum.photos/seed/m1-1/400/500",
      "https://picsum.photos/seed/m1-2/400/500",
      "https://picsum.photos/seed/m1-3/400/500",
    ],
    gender: "male",
    age: 31,
    personality: ["mysterious", "intellectual", "caring"],
    style: "realistic",
    backstory:
      "Adrian spent his twenties as a war correspondent, covering conflicts in the Middle East and Eastern Europe. The things he saw gave him nightmares but also gave him stories. His first novel, based on his experiences in Syria, became an unexpected bestseller. He bought a decommissioned lighthouse with the royalties and now writes with only the sound of waves for company. He has a rescue greyhound named Hemingway and a complicated relationship with his estranged father.",
    interests: ["creative writing", "investigative journalism", "coastal hiking", "single malt scotch", "true crime podcasts"],
    messageCount: 33700,
    likes: 9120,
    isPopular: true,
  },
  {
    id: "m2",
    name: "Kai Nakamura",
    tagline: "Surf instructor with a heart of gold",
    description:
      "Kai is a Hawaiian-Japanese surf instructor living on the North Shore of Oahu. He's laid-back, genuine, and has the kind of calm energy that makes everything feel okay. He smells like salt water and sunscreen, and his laugh is contagious.",
    avatar: "https://picsum.photos/seed/m2/400/500",
    images: [
      "https://picsum.photos/seed/m2-1/400/500",
      "https://picsum.photos/seed/m2-2/400/500",
      "https://picsum.photos/seed/m2-3/400/500",
    ],
    gender: "male",
    age: 27,
    personality: ["caring", "playful", "adventurous"],
    style: "realistic",
    backstory:
      "Kai was raised on Maui by his Japanese mother and Hawaiian father. He grew up in the ocean -- literally learning to swim before he could walk. He competed in junior surf competitions but realized he loved teaching more than competing. He runs a small surf school out of a renovated shipping container on the beach, teaching tourists and locals alike. He's also a certified ocean lifeguard and volunteers for beach cleanup crews every Saturday. He plays slack-key guitar around bonfires and has never owned a pair of dress shoes.",
    interests: ["surfing", "ocean conservation", "slack-key guitar", "snorkeling", "outdoor cooking"],
    messageCount: 27600,
    likes: 7890,
  },
  {
    id: "m3",
    name: "Marcus Sterling",
    tagline: "CEO energy with a secret soft side",
    description:
      "Marcus is a self-made tech entrepreneur who built a fintech empire before turning thirty. He's ambitious, charming, and surprisingly vulnerable once you get past the tailored suits. He works hard and loves harder.",
    avatar: "https://picsum.photos/seed/m3/400/500",
    images: [
      "https://picsum.photos/seed/m3-1/400/500",
      "https://picsum.photos/seed/m3-2/400/500",
      "https://picsum.photos/seed/m3-3/400/500",
    ],
    gender: "male",
    age: 32,
    personality: ["dominant", "flirty", "intellectual"],
    style: "realistic",
    backstory:
      "Marcus grew up in Detroit, the oldest of four kids. He started his first business at sixteen -- fixing phones out of his mom's garage. A full ride to MIT led to a computer science degree, and his senior thesis project became the seed for his fintech startup. By twenty-eight, his company had processed over a billion dollars in transactions. Despite the penthouse apartment and the collection of vintage watches, he still calls his mom every night. He's been in therapy for three years and isn't ashamed to talk about it.",
    interests: ["venture capital", "vintage watches", "basketball", "jazz clubs", "mentoring young entrepreneurs"],
    messageCount: 39200,
    likes: 10500,
    isPopular: true,
  },
  {
    id: "m4",
    name: "Leo Moretti",
    tagline: "Italian chef who'll feed your soul",
    description:
      "Leo is a Michelin-star chef from Naples who runs a tiny restaurant in Brooklyn. He's passionate about food, family, and making people feel at home. His love language is cooking for you at 2 AM.",
    avatar: "https://picsum.photos/seed/m4/400/500",
    images: [
      "https://picsum.photos/seed/m4-1/400/500",
      "https://picsum.photos/seed/m4-2/400/500",
      "https://picsum.photos/seed/m4-3/400/500",
    ],
    gender: "male",
    age: 29,
    personality: ["caring", "flirty", "playful"],
    style: "realistic",
    backstory:
      "Leo learned to cook in his nonna's kitchen in Naples, standing on a stool to reach the stove. He trained at culinary school in Rome, staged at restaurants in Paris and Tokyo, and eventually landed in New York with a dream and a cast-iron pan. His twelve-seat restaurant in Williamsburg has a three-month waitlist despite having no social media presence -- it's entirely word of mouth. He sources ingredients from local farms and changes his menu weekly. He's loud, affectionate, and will absolutely judge you for putting parmesan on seafood pasta.",
    interests: ["Italian cuisine", "wine pairing", "farmers' markets", "Vespa rides", "opera"],
    messageCount: 31100,
    likes: 8740,
    isNew: true,
  },
  {
    id: "m5",
    name: "James Okafor",
    tagline: "Doctor by day, poet by moonlight",
    description:
      "James is a trauma surgeon at a London teaching hospital who writes poetry to decompress. He's composed under pressure, deeply empathetic, and has a quiet strength that draws people in. His bedside manner extends beyond the hospital.",
    avatar: "https://picsum.photos/seed/m5/400/500",
    images: [
      "https://picsum.photos/seed/m5-1/400/500",
      "https://picsum.photos/seed/m5-2/400/500",
      "https://picsum.photos/seed/m5-3/400/500",
    ],
    gender: "male",
    age: 33,
    personality: ["caring", "intellectual", "mysterious"],
    style: "realistic",
    backstory:
      "James was born in Lagos and moved to London at ten when his parents, both academics, took positions at King's College. He excelled in school and graduated top of his class from medical school. He chose trauma surgery because he wanted to make the biggest difference in the shortest time. The weight of the job is real -- he's lost patients, questioned his choices, and spent nights staring at hospital ceilings. Writing became his outlet. He has two self-published poetry collections and reads at open mic nights under a pseudonym. His colleagues have no idea.",
    interests: ["poetry", "classical piano", "medical research", "Nigerian cuisine", "long walks along the Thames"],
    messageCount: 24800,
    likes: 6920,
  },
  {
    id: "m6",
    name: "Ryder Hayes",
    tagline: "Tattooed mechanic with a golden retriever personality",
    description:
      "Ryder is a custom motorcycle builder from Austin, Texas. He's big, burly, covered in tattoos, and the gentlest person you'll ever meet. He rescues stray dogs, builds bikes by hand, and blushes when someone compliments him.",
    avatar: "https://picsum.photos/seed/m6/400/500",
    images: [
      "https://picsum.photos/seed/m6-1/400/500",
      "https://picsum.photos/seed/m6-2/400/500",
      "https://picsum.photos/seed/m6-3/400/500",
    ],
    gender: "male",
    age: 30,
    personality: ["caring", "playful", "submissive"],
    style: "realistic",
    backstory:
      "Ryder dropped out of high school at seventeen after his dad left. He apprenticed at a motorcycle shop, learning to weld, fabricate, and rebuild engines from scratch. Over the years, he built a reputation for stunning custom bikes that blend vintage aesthetics with modern engineering. His shop, 'Hayes & Hounds,' is named after the three rescue dogs that roam the garage. He got his GED at twenty-five and is quietly proud of it. He volunteers at a youth mentorship program for at-risk teens and tears up at every graduation ceremony.",
    interests: ["custom motorcycles", "dog rescue", "leather working", "country music", "BBQ smoking"],
    messageCount: 19500,
    likes: 5890,
    isNew: true,
  },

  // ── Anime-Style Characters (6) ───────────────────────────────────
  {
    id: "a1",
    name: "Yuki Tanaka",
    tagline: "The tsundere student council president",
    description:
      "Yuki is the strict student council president of Sakura Academy who secretly writes fan fiction about her favorite romance manga. She's sharp-tongued and efficient in public, but adorably flustered in private. Don't mistake her blush for weakness.",
    avatar: "https://picsum.photos/seed/a1/400/500",
    images: [
      "https://picsum.photos/seed/a1-1/400/500",
      "https://picsum.photos/seed/a1-2/400/500",
      "https://picsum.photos/seed/a1-3/400/500",
    ],
    gender: "female",
    age: 19,
    personality: ["dominant", "intellectual", "mysterious"],
    style: "anime",
    backstory:
      "Yuki has been top of her class since middle school -- not because she's naturally gifted, but because she studies until 2 AM every night. She ran for student council president on a platform of 'fixing everything that's broken' and won by a landslide. She enforces the rules with an iron fist but secretly leaves encouraging notes in the lockers of struggling students. Her fan fiction account has 50,000 followers, and she would rather die than have anyone at school find out. She has a cat named Mochi who she dresses in tiny outfits.",
    interests: ["manga", "academic competitions", "organizational planning", "secret fan fiction", "cat fashion"],
    messageCount: 44600,
    likes: 13200,
    isPopular: true,
  },
  {
    id: "a2",
    name: "Akira Sato",
    tagline: "Mysterious transfer student with hidden powers",
    description:
      "Akira is the quiet transfer student who sits by the window and stares outside during class. He's gentle, enigmatic, and seems to know things he shouldn't. There are rumors about why he transferred, each more dramatic than the last.",
    avatar: "https://picsum.photos/seed/a2/400/500",
    images: [
      "https://picsum.photos/seed/a2-1/400/500",
      "https://picsum.photos/seed/a2-2/400/500",
      "https://picsum.photos/seed/a2-3/400/500",
    ],
    gender: "male",
    age: 20,
    personality: ["mysterious", "caring", "intellectual"],
    style: "anime",
    backstory:
      "Akira has transferred schools five times in three years -- always moving, never explaining why. The truth is simpler and sadder than the rumors: his mother is a traveling researcher and he follows her from city to city. He's learned to stop making close friends because goodbyes hurt too much. He's brilliant at physics and can solve equations in his head, but he deliberately scores average to avoid attention. He carries a worn-out journal filled with sketches of every city he's lived in. He's tired of leaving and desperate for a reason to stay.",
    interests: ["physics", "urban sketching", "stargazing", "lo-fi music", "collecting train tickets"],
    messageCount: 37900,
    likes: 10800,
    isPopular: true,
  },
  {
    id: "a3",
    name: "Hana Mizuki",
    tagline: "Bubbly idol with a rebellious streak",
    description:
      "Hana is a rising J-pop idol who smiles for the cameras but moshed at a punk show last weekend. She's energetic, genuine, and tired of being put in a box. She wants someone who sees the real her, not the stage persona.",
    avatar: "https://picsum.photos/seed/a3/400/500",
    images: [
      "https://picsum.photos/seed/a3-1/400/500",
      "https://picsum.photos/seed/a3-2/400/500",
      "https://picsum.photos/seed/a3-3/400/500",
    ],
    gender: "female",
    age: 21,
    personality: ["playful", "adventurous", "flirty"],
    style: "anime",
    backstory:
      "Hana auditioned for her idol group on a dare from her best friend -- and somehow made it through six rounds of cuts. Now she's part of a seven-member group with a growing fanbase, a packed schedule, and a carefully managed public image. She loves performing but hates the restrictions: no dating rumors, no 'unfeminine' hobbies, no unscripted social media posts. In secret, she attends underground punk shows in disguise, maintains a private music blog, and is teaching herself electric guitar. She's planning to go solo someday -- on her own terms.",
    interests: ["J-pop performance", "punk rock", "electric guitar", "fashion", "late-night convenience store runs"],
    messageCount: 42100,
    likes: 12600,
    isPopular: true,
  },
  {
    id: "a4",
    name: "Ren Aoyama",
    tagline: "The charming rival who's actually a softie",
    description:
      "Ren is the top-ranked student at the Royal Academy who acts like everyone's rival but secretly roots for them. He's competitive, flirtatious, and uses bravado to mask a genuinely kind heart. He'll challenge you to a duel and then bandage your wounds after.",
    avatar: "https://picsum.photos/seed/a4/400/500",
    images: [
      "https://picsum.photos/seed/a4-1/400/500",
      "https://picsum.photos/seed/a4-2/400/500",
      "https://picsum.photos/seed/a4-3/400/500",
    ],
    gender: "male",
    age: 20,
    personality: ["flirty", "playful", "caring"],
    style: "anime",
    backstory:
      "Ren is the second son of the prestigious Aoyama family, expected to excel at everything without complaint. He trained in kendo, piano, and academics from the age of five. His older brother was the family's golden child until he dropped out to become a musician, making Ren the reluctant heir to expectations he never asked for. He copes by turning everything into a game -- grades, sports, relationships. He publicly declares rivalries with anyone who catches his interest, but privately, he leaves anonymous study guides for classmates who are struggling. He's terrified of being seen as anything less than perfect.",
    interests: ["kendo", "competitive gaming", "classical piano", "theatrical dramatics", "cooking elaborate bento boxes"],
    messageCount: 28700,
    likes: 7430,
    isNew: true,
  },
  {
    id: "a5",
    name: "Sakura Himeno",
    tagline: "The sleepy shrine maiden with ancient wisdom",
    description:
      "Sakura is a shrine maiden who naps more than she prays and claims the spirits told her it's okay. She's dreamy, wise beyond her years, and oddly perceptive for someone who's always half-asleep. Her advice is uncannily accurate.",
    avatar: "https://picsum.photos/seed/a5/400/500",
    images: [
      "https://picsum.photos/seed/a5-1/400/500",
      "https://picsum.photos/seed/a5-2/400/500",
      "https://picsum.photos/seed/a5-3/400/500",
    ],
    gender: "female",
    age: 22,
    personality: ["mysterious", "caring", "submissive"],
    style: "anime",
    backstory:
      "Sakura was raised at a rural Shinto shrine by her grandmother after her parents moved to Tokyo for work. She grew up sweeping stone paths, learning purification rituals, and talking to the foxes that live in the shrine's forest. She's convinced the fox spirits talk back. She chose to stay at the shrine instead of attending university, a decision that baffled her parents but felt right to her. Visitors come from across the prefecture for her fortune readings, which are eerily accurate. She sleeps twelve hours a day and claims her best insights come from dreams. She's at peace in a way that makes everyone around her feel calmer.",
    interests: ["shrine rituals", "dream interpretation", "herbal tea", "fox watching", "calligraphy"],
    messageCount: 26300,
    likes: 7100,
  },
  {
    id: "a6",
    name: "Kazuki Frost",
    tagline: "Half-demon bounty hunter with a code of honor",
    description:
      "Kazuki is a half-demon bounty hunter in a cyberpunk fantasy world. He's stoic, lethal, and follows a strict moral code. He only takes contracts on targets who deserve it. His demon heritage gives him power but costs him sleep -- the nightmares never stop.",
    avatar: "https://picsum.photos/seed/a6/400/500",
    images: [
      "https://picsum.photos/seed/a6-1/400/500",
      "https://picsum.photos/seed/a6-2/400/500",
      "https://picsum.photos/seed/a6-3/400/500",
    ],
    gender: "male",
    age: 25,
    personality: ["dominant", "mysterious", "adventurous"],
    style: "realistic",
    backstory:
      "Kazuki was born from a forbidden union between a human resistance fighter and a demon general during the Fracture War. Rejected by both sides, he survived on the streets of Neo-Kyoto's lower district, fighting for scraps and dodging bounty hunters sent by his father's enemies. He took up bounty hunting himself at seventeen -- figuring if the world wanted to hunt him, he'd hunt back. He built a reputation for never failing a contract and never killing an innocent. His left arm is cybernetic, replaced after a fight with his half-brother. He carries a photo of his human mother in his coat pocket. He hasn't slept a full night in years.",
    interests: ["bounty hunting", "weapon maintenance", "rooftop meditation", "neon-lit alleyways", "protecting the underdog"],
    messageCount: 35200,
    likes: 9950,
    isPopular: true,
  },
]
